import { minorUnitsFromAmount } from '@shared/components/form/config-value';
import { formatMinor } from './topUpAmount';

export interface MotorplanAmountLimits {
    minimumMinor: number;
    maximumMinor: number;
    payOffMinor: number | null;
}

export const payOffMinorFrom = (leftToPay: string): number | null =>
    leftToPay === '' ? null : minorUnitsFromAmount(leftToPay);

export const isPayOffAmount = (amount: string, payOffMinor: number | null): boolean =>
    payOffMinor !== null && minorUnitsFromAmount(amount) === payOffMinor;

const pounds = (minor: number): string => `£${formatMinor(Math.max(minor, 0))}`;

/** Null when the amount is a part payment within range or exactly the pay-off figure. */
export function amountLimitMessage(amountMinor: number, { minimumMinor, maximumMinor, payOffMinor }: MotorplanAmountLimits): string | null {
    if (payOffMinor !== null && amountMinor === payOffMinor) return null;
    const partPaymentPossible = maximumMinor >= minimumMinor;
    if (partPaymentPossible && amountMinor >= minimumMinor && amountMinor <= maximumMinor) return null;

    if (payOffMinor === null) {
        return amountMinor < minimumMinor
            ? `Amount must be at least ${pounds(minimumMinor)}`
            : `Amount must be at most ${pounds(maximumMinor)}`;
    }
    if (!partPaymentPossible) return `Enter ${pounds(payOffMinor)} to pay off the plan`;
    if (amountMinor < minimumMinor) return `Amount must be at least ${pounds(minimumMinor)}`;
    return `Enter up to ${pounds(maximumMinor)} for a part payment, or ${pounds(payOffMinor)} to pay off the plan`;
}
